import { ReactElement } from 'react';
import { Chat1Icon } from '@nx-frontend/shared/ui/icon/icons/chat-1-icon';
import { TasksIcon } from '@nx-frontend/shared/ui/icon/icons/tasks-icon';
import { FileDefault, FolderDefault, HomeDefault, LinkDefault, PageDefault, ToggleDefault } from './icons/default';
import { ProcessDoneIcon } from './icons/process-done-icon';
import { ProcessIcon } from './icons/process-icon';
import { ProcessStepDoneIcon } from './icons/process-step-done-icon';
import { ProcessStepIcon } from './icons/process-step-icon';
import { FileSoft, FolderSoft, HomeSoft, LinkSoft, PageSoft, ToggleSoft } from './icons/soft';

export type IconSetName = 'default' | 'soft';

export enum IconSetKeys {
  'home' = 'home',
  'folder' = 'folder',
  'page' = 'page',
  'note' = 'note',
  'custom_link' = 'custom_link',
  'file' = 'file',
  'toggle' = 'toggle',
  'tasks' = 'tasks',
  'chat' = 'chat',
  'process' = 'process',
  'process_done' = 'process_done',
  'process_step' = 'process_step',
  'process_step_done' = 'process_step_done',
}

export type IconsMap = {
  [key in IconSetKeys]: ReactElement;
};

export const IconsMapDefault: IconsMap = {
  home: <HomeDefault />,
  folder: <FolderDefault />,
  file: <FileDefault />,
  page: <PageDefault />,
  note: <PageDefault />,
  custom_link: <LinkDefault />,
  toggle: <ToggleDefault />,
  tasks: <TasksIcon />,
  chat: <Chat1Icon />,
  process: <ProcessIcon />,
  process_done: <ProcessDoneIcon />,
  process_step: <ProcessStepIcon />,
  process_step_done: <ProcessStepDoneIcon />,
};
export const IconsMapSoft: IconsMap = {
  home: <HomeSoft />,
  folder: <FolderSoft />,
  file: <FileSoft />,
  page: <PageSoft />,
  note: <PageSoft />,
  custom_link: <LinkSoft />,
  toggle: <ToggleSoft />,
  tasks: <TasksIcon />,
  chat: <Chat1Icon />,
  process: <ProcessIcon />,
  process_done: <ProcessDoneIcon />,
  process_step: <ProcessStepIcon />,
  process_step_done: <ProcessStepDoneIcon />,
};

export function getIconsSet(key: IconSetName): IconsMap {
  if (key === 'soft') {
    return IconsMapSoft;
  }
  return IconsMapDefault;
}

export function getIconFromSet(icon: string, iconSet: IconSetName = 'default'): ReactElement {
  const IconSet = getIconsSet(iconSet);
  if (icon in IconSet) {
    return IconSet[icon as IconSetKeys];
  }
  return IconSet.page;
}
